import { render, staticRenderFns } from "./UpdateSpec.vue?vue&type=template&id=9b5039e4&scoped=true"
import script from "./UpdateSpec.vue?vue&type=script&lang=js"
export * from "./UpdateSpec.vue?vue&type=script&lang=js"
import style0 from "./UpdateSpec.vue?vue&type=style&index=0&id=9b5039e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5039e4",
  null
  
)

export default component.exports